import { render, staticRenderFns } from "./UserRoleModal.vue?vue&type=template&id=5dd68297&scoped=true"
import script from "./UserRoleModal.vue?vue&type=script&lang=js"
export * from "./UserRoleModal.vue?vue&type=script&lang=js"
import style0 from "./UserRoleModal.vue?vue&type=style&index=0&id=5dd68297&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd68297",
  null
  
)

export default component.exports